
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Dropdown, Spinner, Modal, Button } from "react-bootstrap";
import { CLOSE_REASONS, CLOSE_REASONS_FOR_SELECT } from "../../lookup/CloseReasonConstants";
import { updateCloseReason } from "./CloseReasonDropdown.actions";

const CloseReasonDropdown = ({ globalSwitchId, closeReason, onSave, wfItemId, onConfirm }) => {
  const dispatch = useDispatch();
  const [selectedReason, setSelectedReason] = useState(closeReason);
  const [isLoading, setIsLoading] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [reasonToConfirm, setReasonToConfirm] = useState(null);

  useEffect(() => {
    setSelectedReason(closeReason);
  }, [closeReason]);

  const handleSelect = (reason) => {
    const VERIFIED_MBR_KEY = "Verified Mbr is patient";

    if (reason === VERIFIED_MBR_KEY) {
      setReasonToConfirm(reason);
      setShowConfirmModal(true);
    } else {
      proceedWithUpdate(reason);
    }
  };

  const proceedWithUpdate = (reason) => {
    setIsLoading(true);
    setSelectedReason(reason);
    dispatch(updateCloseReason(wfItemId, reason)).then(() => {
      setIsLoading(false);
      if (onSave) {
        onSave();
      }
    }).catch(() => {
      setIsLoading(false);
    });
  };

  const handleConfirm = () => {
    setShowConfirmModal(false);
    setIsLoading(true);
    if (reasonToConfirm) {
      if (onConfirm) {
        // Pass a callback to reset loading state
        onConfirm(reasonToConfirm, wfItemId, globalSwitchId, () => setIsLoading(false));
      }
    }
    setReasonToConfirm(null);
  };

  const handleCancel = () => {
    setShowConfirmModal(false);
    setReasonToConfirm(null);
  };

  return (
    <>
      {isLoading ? (
        <div className="w-100 text-center">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : (
        <Dropdown onSelect={handleSelect} disabled={isLoading}>
          <Dropdown.Toggle variant="outline-secondary" id="dropdown-basic">
            {selectedReason || "Select Reason"}
          </Dropdown.Toggle>

          <Dropdown.Menu className="max-h-200 overflow-auto">
            {CLOSE_REASONS_FOR_SELECT.map((reason) => (
              <Dropdown.Item key={reason.key} eventKey={reason.key}>
                {reason.value}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      )}
      <Modal show={showConfirmModal} onHide={handleCancel} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Action</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to select "{reasonToConfirm}"? This action will schedule a prescriber fax immediately.  </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCancel}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleConfirm}>
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CloseReasonDropdown;
